module.exports = __webpack_public_path__ + "static/media/2dclustering.1d11c49b.svg";